/* eslint-disable tailwindcss/no-arbitrary-value */
import React, { useState } from 'react';
import { string, func } from 'prop-types';
import { CardMedia, Button, TextField } from '@one-thd/sui-atomic-components';

export const RebateSearchBar = ({
  value: valueProp,
  onSearch
}) => {
  const [value, setValue] = useState(valueProp);

  const onSubmit = (event) => {
    event.preventDefault();
    onSearch(value);
  };

  const onInputChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <form className="sui-flex sui-items-center sui-w-[100%] xl:sui-w-[45%]" onSubmit={onSubmit}>
      <TextField
        placeholder="Search for Product with Rebates"
        value={value}
        onChange={onInputChange}
        fullWidth
      />
      <Button
        className="sui-h-[43px] sui-w-[43px] sui-mt-2"
        onClick={onSubmit}
        data-testid="rebate-search-button"
      >
        <CardMedia
          src="https://assets.homedepot-static.com/images/v1/search-orange.svg"
          alt="Search Rebates"
          className="sui-w-[43px] sui-h-[43px]"
        />
      </Button>
    </form>
  );
};

RebateSearchBar.propTypes = {
  value: string,
  onSearch: func
};

RebateSearchBar.defaultProps = {
  value: '',
  onSearch: () => { }
};

RebateSearchBar.displayName = 'RebateSearchBar';
